import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Trophy, Sparkles, Share2, History, ChevronDown, ChevronUp } from "lucide-react";
import { openPotwCard } from "../../lib/potwCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PlayerOfWeekBanner = ({ playerId }) => {
  const [data, setData] = useState(null);
  const [history, setHistory] = useState([]);
  const [showHist, setShowHist] = useState(false);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/potw/current`).then((r) => { if (alive) setData(r.data?.winner ? r.data : null); }).catch(() => {});
    axios.get(`${API}/potw/history?limit=12`).then((r) => { if (alive) setHistory(r.data?.history || []); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!data?.winner) return null;
  const w = data.winner;
  const isYou = playerId && w.player_id === playerId;

  return (
    <motion.div
      data-testid="potw-banner"
      initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}
      className="relative overflow-hidden rounded-xl border border-[#D4AF37]/45 bg-gradient-to-r from-[#1a1508] via-[#141007] to-[#0d0d0d] px-4 sm:px-5 py-3.5 mb-6"
    >
      <div className="absolute -right-6 -top-8 opacity-10 pointer-events-none"><Trophy size={120} className="text-[#D4AF37]" /></div>
      <div className="relative flex items-center gap-3 flex-wrap">
        <div className="w-10 h-10 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/50 flex items-center justify-center shrink-0">
          <Trophy size={19} className="text-[#D4AF37]" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#D4AF37] flex items-center gap-1.5">
            Player of the Week {isYou && <Sparkles size={12} />}
            {data.week_of && <span className="text-white/35 tracking-normal normal-case">· Week of {data.week_of}</span>}
          </div>
          <div className="text-white font-headings text-lg uppercase tracking-wide leading-tight mt-0.5">
            {isYou ? <>That's you — <span className="text-[#D4AF37]">{w.name}</span>! 🎉</> : <>{w.name}</>}
          </div>
          <div className="text-xs text-white/55 mt-0.5">{w.points} pts{w.streak ? ` · 🔥 ${w.streak}-day streak` : ""} · Central Illinois #1</div>
        </div>
        <button data-testid="potw-share-btn" onClick={() => openPotwCard({ name: w.name, points: w.points, streak: w.streak, weekOf: data.week_of })}
          className="inline-flex items-center gap-1.5 bg-[#D4AF37] hover:brightness-110 text-black text-[10px] font-bold uppercase tracking-wider px-3 py-2 rounded-md transition-all shrink-0">
          <Share2 size={13} /> {isYou ? "Share My Win" : "Share Card"}
        </button>
      </div>

      {history.length > 0 && (
        <div className="relative mt-3 pt-3 border-t border-white/10">
          <button data-testid="potw-history-toggle" onClick={() => setShowHist((s) => !s)}
            className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-white/45 hover:text-white/80 transition-colors">
            <History size={12} /> Hall of Fame ({history.length}) {showHist ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
          </button>
          {showHist && (
            <div className="mt-2 space-y-1" data-testid="potw-history-list">
              {history.map((h, i) => (
                <div key={h.week_key || i} className="flex items-center gap-2 text-xs">
                  <Trophy size={11} className="text-[#D4AF37]/70 shrink-0" />
                  <span className="text-white/80 font-semibold">{h.winner?.name}</span>
                  <span className="text-white/30">·</span>
                  <span className="text-white/40">{h.winner?.points} pts</span>
                  <span className="text-white/25 ml-auto">{h.week_of}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </motion.div>
  );
};

export default PlayerOfWeekBanner;
